/**
 * Routes, at two levels.
 *
 * Site-level pages sit at the root. Everything about a world sits under the
 * world's slug, which comes from the database: `/:world` is whatever
 * `universes.slug` says, and a second world needs no route of its own. The
 * site-level paths are reserved (src/shared/routes.ts), so a world can never
 * take one.
 *
 * Every path is Latin, per CLAUDE.md — there is no Cyrillic in a URL on this
 * site, in any language. The catalogue's URLs from before there were worlds
 * (`/series`, `/books`, ...) are redirected by the Worker, and never reach
 * this router.
 */

import { Route, Routes } from 'react-router'
import { SiteLayout, WorldLayout } from './components/Layout.tsx'
import { About } from './routes/About.tsx'
import { Account } from './routes/Account.tsx'
import { Book } from './routes/Book.tsx'
import { Contact } from './routes/Contact.tsx'
import { Books } from './routes/Books.tsx'
import { ForgotPassword } from './routes/ForgotPassword.tsx'
import { OutsideSeries } from './routes/OutsideSeries.tsx'
import { Quiz } from './routes/Quiz.tsx'
import { Privacy } from './routes/Privacy.tsx'
import { Register } from './routes/Register.tsx'
import { ResetPassword } from './routes/ResetPassword.tsx'
import { SeriesDetail } from './routes/SeriesDetail.tsx'
import { SeriesIndex } from './routes/SeriesIndex.tsx'
import { SignIn } from './routes/SignIn.tsx'
import { Terms } from './routes/Terms.tsx'
import { VerifyEmail } from './routes/VerifyEmail.tsx'
import { WorldHome } from './routes/WorldHome.tsx'
import { Worlds } from './routes/Worlds.tsx'

export function App() {
  return (
    <Routes>
      <Route element={<SiteLayout threshold />}>
        <Route path="/" element={<Worlds />} />
      </Route>
      <Route element={<SiteLayout />}>
        <Route path="/register" element={<Register />} />
        <Route path="/verify" element={<VerifyEmail />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/account" element={<Account />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
      </Route>

      {/* A world. Public, no account needed for any of it. */}
      <Route path="/:world" element={<WorldLayout />}>
        <Route index element={<WorldHome />} />
        <Route path="series" element={<SeriesIndex />} />
        <Route path="series/:slug" element={<SeriesDetail />} />
        <Route path="books" element={<Books />} />
        <Route path="books/:slug" element={<Book />} />
        <Route path="outside" element={<OutsideSeries />} />
        <Route path="quiz" element={<Quiz />} />
      </Route>
    </Routes>
  )
}
